import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { ContentsBase } from '@routes/tickets/ticket-edit/contents/contents-base';
import { finalize, takeWhile } from 'rxjs/operators';
import { TicketCreate } from '@shared/models/ticket-create';
import Utils from '@shared/utils/utils';
import { Customer } from '@shared/models/customer';
import { Sc4uInfo } from '@shared/models/sc4u-info';
import { Symptom } from '@shared/models/symptom';
import { Product } from '@shared/models/product';
import { Basic } from '@shared/models/basic';
import * as _ from 'lodash-es';
import * as moment from 'moment-timezone';
import { ServiceCenter } from '@shared/models/ticket-info';
import { FormGroup } from '@angular/forms';
import DateUtils from '@shared/utils/date-utils';
import Configs from '@shared/constants/configs';
import { Company } from '@shared/enums/company';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-schedule',
  templateUrl: './schedule.component.html',
  styleUrls: ['./schedule.component.scss']
})
export class ScheduleComponent extends ContentsBase implements OnInit, OnDestroy, AfterViewInit {

  readonly moment = moment;

  basic: Basic = {};
  customer: Customer = {};
  product: Product = {};
  sc4uInfo: Sc4uInfo = {};
  symptoms: Symptom[] = [];
  scheduleDate: Date = null;

  serviceCenter: ServiceCenter = {};
  serviceCenters: ServiceCenter[] = [];
  serviceCentersSchedule: any[] = [];
  pagingDate: any;

  bsConfig = {
    containerClass: 'theme-dk',
    showWeekNumbers: false,
    dateInputFormat: Configs.format.date,
  };
  scheduleForm: FormGroup = null;
  beforeDate = null;

  companies = Company;
  preferredServiceCenters = [];
  otherServiceCenters = [];
  userAgreement = false;
  SPECIAL_ASC_LENNAR;

  get form(): any {
    return this.scheduleForm?.controls;
  }

  ngOnInit(): void {
    this.init('schedule');
    this.reloadTicket();
  }

  reloadTicket(): void {
    if (this.ticketService) {
      this.ticketService.data$
        .pipe(takeWhile(() => this.alive))
        .subscribe((ticket: TicketCreate) => {

          // console.log('# schedule ticketService.data$::>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> ', ticket);
          if (Utils.isEmpty(ticket)) {
            return;
          }
          // console.log('>>>>>>>>>> ngOnInit::ticket =', ticket);
          ['basic', 'customer', 'product', 'sc4uInfo', 'symptoms', 'serviceCenters', 'serviceCenter', 'scheduleDate'].forEach(x => {
            this[x] = ticket[x];
            // console.log('------------ this[',x, '] =',this[x]);
          });

          if (this.isDetail && this.scheduleDate) {
            if (!this.scheduleForm) {
              this.scheduleForm = this.setFormControls('scheduleForm');
              this.form.scheduleDate.valueChanges.subscribe(sd => {
                this.changeScheduleDate(sd);
              });
              this.form.scheduleTime.valueChanges.subscribe(st => {
                this.changeScheduleDate(st);
              });
            }

            if (this.scheduleDate && !this.form.scheduleDate.value) {
              this.beforeDate = new Date(DateUtils.localDate(this.beforeDate || this.scheduleDate));
              const scheduleDateTime = DateUtils.utc2HQDateOptionalTime(ticket.scheduleDate);
              this.form.scheduleDate.setValue(scheduleDateTime);
              this.form.scheduleTime.setValue(scheduleDateTime);
            }

            if (this.isDealer) {
              const fields = ['scheduleDate', 'scheduleTime'];
              this.setFormControlDisable(this.form, fields);
            }
            return;
          }
          if (this.customer?.address?.zipcode && !this.serviceCenters &&
            ![this.constants.specialAsc.NO_ASC.ascNo, this.constants.specialAsc.NO_ASC_FOR_SI.ascNo].includes(this.serviceCenter?.ascNo)) {
            this.load();
          }
        });
    }
  }

  ngAfterViewInit(): void {
    // this.ticketService.scrollToBottom();
  }

  ngOnDestroy(): void {
    this.alive = false;
  }

  load() {
    const isPs = this.basic.serviceType === this.constants.serviceCode.PICKUP_SERVICE;
    // console.log('this.product =', this.product);
    // console.log('this.symptoms =', this.symptoms);
    // console.log('isPs =', isPs);
    if (!this.product || (!isPs && !this.symptoms) || (!isPs && !this.symptoms.length)) {
      return;
    }
    // console.log('this.basic = ', this.basic);
    // console.log('this.customer = ', this.customer);
    const { serviceType, dealer } = this.basic;
    const { address } = this.customer;
    const { modelCode, warrantyTerm } = this.product;
    const { sc4uTarget } = this.sc4uInfo || {};

    let symptoms = [];

    this.SPECIAL_ASC_LENNAR = dealer.bpNo === this.constants.specialAsc.ASC_FOR_LENNAR.bpNo ? this.constants.specialAsc.ASC_FOR_LENNAR.ascNo : '';
    console.log('this.SPECIAL_ASC_LENNAR = ', this.SPECIAL_ASC_LENNAR)
    if (this.symptoms) {
      symptoms = this.symptoms?.map(m => {
        return m.code;
      });
    }
    const isPick = !this.isDetail && [this.companies.Seca].includes(this.company);
    this.spinnerService.start();
    this.apiService.locator.getServiceCenters(modelCode, symptoms, address.zipcode, sc4uTarget, serviceType, warrantyTerm)
      .pipe(finalize(() => this.spinnerService.stop()))
      .subscribe(res => {
        const serviceCenters = res?.serviceCenters.map(serviceCenter => {
          const preferredLabel = serviceCenter.centerType === 'ASC' ? 'Other' : 'Preferred'
          return {
            ...serviceCenter,
            preferredLabel
          }
        });
        if (!serviceCenters.length || isPick || this.constants.specialAsc.ASC_FOR_LENNAR.bpNo === dealer?.bpNo) {
          return;
        }
        res.serviceCenters = serviceCenters;
        // console.log('55555555 >> load =', res.serviceCenters);

        res.serviceCenters.map(sc => sc.preferredLabel === 'Other' ? this.otherServiceCenters.push(sc) : this.preferredServiceCenters.push(sc));

        this.serviceCenterConfig(serviceCenters, 0);
        this.ticketService.patch(res, 'schedule');
      }, err => Utils.showError(err));
  }

  onPageEvent(pageEvent) {
    let weekIdx;
    if (pageEvent === 'Prev') {
      weekIdx = 0;
      this.pagingDate.prevDate = this.pagingDate.firstElement;
    }
    if (pageEvent === 'Next') {
      weekIdx = 1;
      this.pagingDate.prevDate = this.pagingDate.lastElement;
    }

    this.scheduleData(this.preferredServiceCenters, weekIdx);
  }

  onSelected(data, schedule, key) {
    const serviceCenter = _.cloneDeep(data);
    serviceCenter.schedule = schedule;
    serviceCenter.schedule.key = key;

    this.ticketService.patch({ serviceCenter }, 'selected ServiceCenter');
  }

  onSelectedPick(data, schedule) {
    let serviceCenter: any;
    if (!Utils.isEmpty(this.serviceCenter) && schedule === null) {
      serviceCenter = null;
    } else {
      serviceCenter = _.cloneDeep(data);
      serviceCenter.schedule = schedule;
      serviceCenter.availableBE = [];
      serviceCenter.serviceCenterType = data.centerType;

      if (data.preferredLabel === 'Other') {
        this.preferredServiceCenters.map(sc => {
          const centerSchedule = []
          sc.schedules.map(schedule => {
            const startIndex = schedule.date.indexOf('-') + 1;
            const endIndex = schedule.date.length;
            const subDate = schedule.date.substring(startIndex, endIndex).replace('-', '/');
            centerSchedule.push(subDate)
          });
          const centerScheduleString = `${ sc.ascNo }(${ centerSchedule.join(',') })`;

          serviceCenter.availableBE.push(centerScheduleString);
        });
      }
    }
    this.ticketService.patch({ serviceCenter }, 'selected ServiceCenter');
  }

  onNoServiceCenterSelectPick() {
    if (!this.basic) {
      this.reloadTicket();
    }
    const serviceCenter = !this.serviceCenter ? {
      ascNo: this.basic.dealer.bpNo === this.constants.specialAsc.ASC_FOR_LENNAR.bpNo ? this.constants.specialAsc.ASC_FOR_LENNAR.ascNo
        : [this.constants.serviceCode.COSMETIC_REPAIR, this.constants.serviceCode.INSTALL_CHECKING].includes(this.basic.serviceType) ? this.constants.specialAsc.NO_ASC_FOR_SI.ascNo : this.constants.specialAsc.NO_ASC.ascNo
      // ascNo: this.constants.specialAsc.NO_ASC.ascNo,
    } : null;
    this.ticketService.patch({ serviceCenter }, 'selected ServiceCenter');
  }

  changeScheduleDate(value: any) {
    if (!value) {
      return;
    }

    let { scheduleDate, scheduleTime } = this.scheduleForm.getRawValue();
    if (!scheduleDate) {
      return;
    }
    scheduleTime = scheduleTime || DateUtils.getMidnight();
    scheduleDate = DateUtils.toLocalMomentWithoutChangingTime(scheduleDate, scheduleTime, Configs.format.serverLocalDateTime2);

    this.ticketService.patch({ scheduleDate }, 'changeScheduleDate');
  }

  resetScheduleDate() {
    const data = {
      serviceCenter: null,
      serviceCenters: null,
      scheduleDate: null,
    };
    this.ticketService.patch(data, 'ScheduleComponent :: resetScheduleDate');
  }

  openPopUp() {
    Swal.fire({
      text: 'Samsung strongly recommends using one of our Preferred service providers.',
      showCancelButton: false,
      confirmButtonText: 'Ok',
    }).then((result) => {
      if (result.isConfirmed) {
        this.userAgreement = true;
      }
    });
  }

  private serviceCenterConfig(serviceCenters, idx) {
    if (!serviceCenters) {
      return;
    }

    this.serviceCentersSchedule = [];

    for (const serviceCenter of serviceCenters) {
      if (serviceCenter.schedules) {
        const result = Utils.chunkArray(serviceCenter.schedules, 7);
        this.serviceCentersSchedule.push(result[idx]);
      }
    }

    const firstSchedule = _.first(_.first(this.serviceCentersSchedule));
    const lastSchedule = _.last(_.last(this.serviceCentersSchedule));

    this.pagingDate = {
      firstElement: firstSchedule ? firstSchedule['date'] : null,
      lastElement: lastSchedule ? lastSchedule['date'] : null,
      prevDate: firstSchedule ? firstSchedule['date'] : null,
    };
  }

  private scheduleData(serviceCenters, idx) {
    this.serviceCentersSchedule = [];

    for (const serviceCenter of serviceCenters) {
      if (serviceCenter.schedules) {
        const result = Utils.chunkArray(serviceCenter.schedules, 7);
        this.serviceCentersSchedule.push(result[idx]);
      }
    }
  }
}
